<script setup lang="ts">
/* This file can't contain any editor/store logic */
import { XIcon } from "~/icons";
</script>

<template>
  <div class="absolute -top-1.5 right-0 hidden h-1.5 w-3 group-hover/smart-match:flex" />
  <div class="absolute top-0 -right-1.5 hidden h-3 w-1.5 group-hover/smart-match:flex" />
  <button
    type="button"
    aria-label="Decline match"
    class="dart-smart-match-close absolute -top-1.5 -right-1.5 z-10 hidden icon-xs cursor-pointer items-center justify-center rounded-full border border-md bg-lt group-hover/smart-match:flex">
    <XIcon class="size-full text-lt" />
  </button>
</template>
